import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export const CookieConsent = () => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const t = setTimeout(() => {
            if (!localStorage.getItem("cookie_accept")) setShow(true);
        }, 800);
        return () => clearTimeout(t);
    }, []);
    if (!show) return null;
    return (
        <div data-testid="cookie-consent" className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:w-[420px] z-[60] bg-white rounded-2xl shadow-2xl border border-gray-100 p-5">
            <div className="flex items-start gap-3">
                <div className="shrink-0 w-9 h-9 rounded-xl bg-[#D4A537]/15 text-[#D4A537] flex items-center justify-center">
                    <Cookie size={18} />
                </div>
                <div className="flex-1">
                    <p className="font-serif text-base text-[#092E22] mb-1">Pliki cookie i prywatność</p>
                    <p className="text-xs text-gray-600 leading-relaxed">
                        Używamy plików cookie niezbędnych do działania strony. Korzystając z serwisu akceptujesz naszą {" "}
                        <Link to="/polityka-prywatnosci" className="text-[#0D4F3C] underline">politykę prywatności</Link>.
                    </p>
                </div>
            </div>
            <div className="flex justify-end mt-3">
                <button
                    onClick={() => { localStorage.setItem("cookie_accept", "1"); setShow(false); }}
                    data-testid="cookie-accept-btn"
                    className="px-5 py-2 rounded-full bg-[#0D4F3C] hover:bg-[#092E22] text-white text-xs font-semibold transition-all"
                >
                    Akceptuję
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;
